(ns app.front.view.approval.core
  (:require [app.front.process :as process]
            [app.front.ui.section :as section]
            [app.front.util :as futil]
            [app.front.view.approval.filters :as approval-filters]
            [app.front.view.approval.form :as approval-form]
            [app.front.view.approval.table :as approval-table]
            [app.front.view.workspace.section :as ws-section]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]
            [re-frame.core-instrumented :as rf]))

;; Events
(rf/reg-event-db ::add-request
  #(assoc % ::approval-form/new-circulation-form-open true))

(rf/reg-event-db ::initialize-add-request-v2
  (fn [db [_ default-approver-groups]]
    (-> db
        (assoc ::approval-form/new-circulation-form-open true)
        (assoc ::approval-form/new-circulation-data approval-form/default-new-circulation-state)
        (assoc-in [::approval-form/new-circulation-data :targets]
                  (or (->> default-approver-groups
                           (map #(hash-map :target-group-id %))
                           seq)
                      [])))))

(rf/reg-event-fx ::add-request-and-scroll
  (fn [{:keys [db]} [_ default-approver-groups]]
    {:db                       (if (ff/enabled? :feature-flag.id/multi-circulation-requests)
                                 (-> db
                                     (assoc ::approval-form/new-circulation-form-open true)
                                     (assoc ::approval-form/new-circulation-data approval-form/default-new-circulation-state)
                                     (assoc-in [::approval-form/new-circulation-data :targets]
                                               (or (->> default-approver-groups
                                                        (map #(hash-map :target-group-id %))
                                                        seq)
                                                   [])))
                                 (assoc db ::approval-form/new-circulation-form-open true))
     ::futil/scroll-to-section :application-approvals}))

(rf/reg-sub ::approval-section-visible?
  (fn [[_ fsm-target] _]
    [(rf/subscribe [::approval-form/approvals (:db/id fsm-target)])
     (rf/subscribe [::process/signal-permitted? fsm-target [:process.signal/create-approval]])
     (rf/subscribe [::ff/enabled? :feature-flag.id/inspection-ui-improvements])
     (rf/subscribe [::approval-form/new-circulation-form-open])])
  (fn [[approvals create-permitted? ui-improvements? form-open?] _]
    (if ui-improvements?
      (or (seq approvals) form-open?)
      (or (seq approvals) create-permitted?))))

(defn approval-components [{:keys [process-target] :as state}]
  [:<>
   (when (<sub [::approval-form/new-circulation-form-open])
     [:div.mb-6
      [approval-form/new-approval-form state]])
   (when (<sub [::approval-form/has-approvals? (:db/id process-target)])
     [:<>
      (when (<sub [::ff/enabled? :feature-flag.id/circulation-table-sorting-and-filters])
        [approval-filters/approval-filters state])
      [:div.mt-6
       [approval-table/approval-table state]]])])

(defn approvals [{:keys [tr fsm-target] :as state}]
  (when (<sub [::approval-section-visible? fsm-target])
    (if (<sub [::ws-subs/loading-config?])
      (section/section-skeleton)
      (let [default-approver-groups (<sub [::ws-subs/default-approver-groups])]
        [ws-section/section
         fsm-target
         :application-approvals
         (if (<sub [:app.front.process/signal-permitted?
                    fsm-target
                    [:process.signal/create-approval]])
           (assoc state :heading-button (cc/button {:icon             i/plus
                                                    :icon-description (tr [:approval/add-request])
                                                    :kind             :ghost
                                                    :on-click         #(>evt (if (ff/enabled? :feature-flag.id/multi-circulation-requests)
                                                                               [::initialize-add-request-v2 default-approver-groups]
                                                                               [::add-request]))}
                                                   (tr [:approval/add-request])))
           state)
         :approval/approvals
         true
         [approval-components (assoc state :process-target fsm-target
                                     :default-approver-groups default-approver-groups)]]))))
